
import React, { useState, useRef, useEffect } from 'react';
import { useForm } from "react-hook-form";
import {
    Box, Button, FormControl, FormControlLabel, Grid, IconButton, Dialog, DialogTitle, DialogContent,
    InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, TextField, Typography, Divider, Tooltip, Card, Checkbox
} from '@mui/material';
import axios from 'axios'
import { useLocation, useNavigate } from "react-router-dom";
import { Info } from '@mui/icons-material';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import styles from '.././../../styles.module.css';
import { ERPinput, ERPinputNo } from '../../reusableComponent/ErpTextField';
import { useDispatch, useSelector } from 'react-redux';
import { dateConversionOnEntryPage } from '../../reusableComponent/dateConversionOnEntryPage';
import { addDocNoFormate, editDeleteDocNoFormate } from '../../../actions/actions';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';

const DocumentNumbringFormate = (props) => {
    const dispatch = useDispatch()

    const { handleSubmit } = useForm();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let navigate = useNavigate();
    const urlLocation = useLocation();
    const editData = urlLocation.state;
    // const editData = props.details && props.details;
    const editid = editData && editData.id;
    const [successMessage, setSuccessMessage] = useState(null);
    const [preview, setPreview] = useState(editData ? editData.preview : '');
    const [fromStarting, setFromStarting] = React.useState('0');
    const [openSnak, setOpenSnak] = React.useState(false);

    const date_ob = new Date();
    const hours = date_ob.getHours();
    const minutes = date_ob.getMinutes();
    const seconds = date_ob.getSeconds();
    const milliseconds = date_ob.getMilliseconds();
    const currentTime = hours + ":" + minutes + ":" + seconds + ":" + milliseconds;

    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISODateTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);

    const [data, setData] = useState({
        id: editid,
        documentTypeName: editData ? editData.documentTypeName : '',
        prefix: editData ? editData.prefix : '',
        seperatorFirst: editData ? editData.seperatorFirst : '',
        seperatorSecond: editData ? editData.seperatorSecond : '',
        // fromStarting: editData ? editData.fromStarting : '0',
        digit: editData ? editData.digit : '',
        year: editData ? editData.year : '',
        startNo: editData ? editData.startNo : '1',
        format: editData ? editData.format : '0',
    })

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;

        if (target.name == 'fromStarting') {
            data['fromStarting'] = value ? value : 0
        }
        if (target.name == 'startNo') {
            data['startNo'] = value ? value : 0
        }
        let fromStartingValue = data['startNo'] ;
        setFromStarting(fromStartingValue)
        let PreviewValue = data['prefix'] + data['seperatorFirst']
            + parseInt(fromStartingValue).toString().padStart((data['digit']), '0') + data['seperatorSecond'] + data['year'];
        setPreview(PreviewValue)
        setSuccessMessage(null);
     
    }


    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.docNoFormate.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'Document No Formate name already available!') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);

    const onSubmit = (event) => {
        let documentData = {
            ...data,
            preview: preview,
            fromStarting:fromStarting,
            changeWithFinYear: changeWithFinYear,
            companyId: userInfo.companyId,
            createdBy: editData ? editData.createdBy : userInfo.userId,
            createdAt: editData ? editData.createdAt : dateConversionOnEntryPage(new Date()),
            modifiedBy: editData ? userInfo.userId : null,
            modifiedAt: editData ? dateConversionOnEntryPage(new Date()) : '',
            changedUpdatedValue: 'edit',
        }

        if (editData) {
            dispatch(editDeleteDocNoFormate(documentData));
        } else {
            dispatch(addDocNoFormate(documentData));
        }
        // props.onAPISubmt();
        // props.handleCloseDialog();
    }



    const [changeWithFinYear, setChangeWithFinYear] = useState(false)
    const handleChangeCheckbox = ({ target }) => {
        let value = target.checked;
        setChangeWithFinYear(value == true ? 1 : 0);
    }

    return (
        <>
            <div>
                <Breadcrumb
                    routeSegments={[
                        { name: 'Settings', path: '/settings' },
                        { name: 'Document Number Format List', path: '/doc-no-format' },
                        { name: 'Create Document Number Format' },
                    ]}
                />
                <Paper className={`${styles.list_container}`}>

                    {/* <Box sx={{ display: 'flex', paddingLeft: '50px' }}>
                        <Grid container spacing={0.2} sx={{ mt: 2, pb: 2 }}>
                            <Grid item md={12} xs={12}>
                                <Typography className={`${styles.page_title}`}>Create Document NUmber Format</Typography>
                            </Grid>
                        </Grid>
                    </Box> */}
                    <Box sx={{ m: 4 }} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)} onError={() => null}>
                        <Grid container spacing={2} style={{ minHeight: '350px', paddingLeft: '50px' }}>
                            <Grid item xs={4} >
                                <Typography > Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                </Typography>
                            </Grid>
                            <Grid item xs={8} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                                <Card className={`${styles.m_card}`}>
                                    <Grid container spacing={2} sx={{ p: 1, mt: 1 }}>
                                        <Grid item xs={6}>
                                            <FormControl fullWidth size='small'>
                                                <InputLabel id="demo-simple-select-label" sx={{ fontSize: 12 }}>Document Name</InputLabel>
                                                <Select
                                                    sx={{
                                                        height: 30,
                                                        fontSize: 12
                                                    }}
                                                    MenuProps={{ PaperProps: { sx: { maxHeight: 150 } } }}
                                                    label='Document Name'
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    size='small'
                                                    value={data.documentTypeName}
                                                    name="documentTypeName"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: editData ? true : false,
                                                    }}
                                                    disabled={editData ? true : false}
                                                >
                                                    <MenuItem value="Sales Invoice" className={`${styles.erp_lable}`}>Sales Invoice</MenuItem>
                                                    <MenuItem value="Purchase Invoice" className={`${styles.erp_lable}`}>Purchase Invoice</MenuItem>
                                                    <MenuItem value="Purchase Order" className={`${styles.erp_lable}`}>Purchase Order</MenuItem>
                                                    <MenuItem value="Sales Order" className={`${styles.erp_lable}`}>Sales Order</MenuItem>
                                                    <MenuItem value="Quotation" className={`${styles.erp_lable}`}>Quotation</MenuItem>
                                                    <MenuItem value="Delivery Challan" className={`${styles.erp_lable}`}>Delivery Challan</MenuItem>
                                                    <MenuItem value="Production" className={`${styles.erp_lable}`}>Production</MenuItem>
                                                    <MenuItem value="Proforma Invoice" className={`${styles.erp_lable}`}>Proforma Invoice</MenuItem>
                                                    {/* <MenuItem value="D C Rework" className={`${styles.erp_lable}`}>D C Rework </MenuItem> */}
                                                    {/* <MenuItem value="Inward Challan" className={`${styles.erp_lable}`}>Inward Challan </MenuItem> */}
                                                    {/* <MenuItem value="GRN" className={`${styles.erp_lable}`}>GRN</MenuItem> */}
                                                    {/* <MenuItem value="Credit Note" className={`${styles.erp_lable}`}>Credit Note</MenuItem> */}
                                                    {/* <MenuItem value="Debit Note" className={`${styles.erp_lable}`}>Debit Note</MenuItem> */}
                                                    {/* <MenuItem value="Job Card" className={`${styles.erp_lable}`}>Job Card</MenuItem> */}
                                                    {/* <MenuItem value="Sales Enquiry" className={`${styles.erp_lable}`}>Sales Enquiry</MenuItem> */}
                                                    {/* <MenuItem value="Rate Contract" className={`${styles.erp_lable}`}>Rate Contract</MenuItem> */}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2} sx={{ p: 1, pt: 2, pb: 2 }}>
                                        <Grid item xs={12} >
                                            <TextField
                                                fullWidth
                                                label='Preview'
                                                type="text"
                                                // disabled={true}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { fontSize: 30, color: '#000000' }
                                                }}
                                                InputProps={{
                                                    // disableUnderline: true,
                                                    style: { fontSize: 30, fontWeight: 'bold' }
                                                }}
                                                name="preview"
                                                value={preview}
                                            />
                                            <br />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2} sx={{ p: 1 }}>
                                        <input type="hidden" name="preview" value={preview} placeholder="Preview" />
                                        <Grid item xs={2} >
                                            <ERPinput
                                                fullWidth
                                                label='Prefix'
                                                size='small'
                                                type="text"
                                                onChange={handleChange}
                                                name="prefix"
                                                value={(data.prefix)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { fontSize: 12, color: '#000000' }
                                                }}
                                                inputProps={{ style: { fontSize: 12, } }}

                                            />
                                        </Grid>
                                        <Grid item md={2} >
                                            <ERPinput
                                                fullWidth
                                                label='Seperator'
                                                name="seperatorFirst"
                                                value={(data.seperatorFirst)}
                                                size="small"
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { fontSize: 12, color: '#000000' }
                                                }}
                                                onChange={handleChange}
                                                select
                                            >
                                                <MenuItem value="" className='textFont' selected>Not Required</MenuItem>
                                                <MenuItem value="/" className='textFont'>/</MenuItem>
                                                <MenuItem value="_" className='textFont'>_</MenuItem>
                                            </ERPinput>

                                        </Grid>
                                        <Grid item md={2} style={{ display: 'flex', justifyContent: 'center', }}>

                                            <ERPinputNo
                                                fullWidth
                                                label='Digit'
                                                size='small'
                                                type="number"
                                                onChange={handleChange}
                                                name="digit"
                                                value={(data.digit)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { fontSize: 12, color: '#000000' }
                                                }}
                                                onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 1)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={2}>
                                            <ERPinputNo style={{display:'none'}}
                                                fullWidth
                                                label='From Starting'
                                                size='small'
                                                type="number"
                                                onChange={handleChange}
                                                name="fromStarting"
                                                value={(parseInt(fromStarting).toString().padStart((data.digit), '0'))}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { fontSize: 12, color: '#000000' }
                                                }}
                                            />
                                            <ERPinput
                                                fullWidth
                                                label='Format'
                                                size='small'
                                                type="text"
                                                onChange={handleChange}
                                                name="format"
                                                value={(parseInt(data.format).toString().padStart((data.digit), '0'))}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { fontSize: 12, color: '#000000' }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={2} style={{}}>
                                            <ERPinput fullWidth
                                                label='Seperator'
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { fontSize: 12, color: '#000000' }
                                                }}
                                                name="seperatorSecond"
                                                value={(data.seperatorSecond)}
                                                size="small"
                                                onChange={handleChange}
                                                select
                                            >
                                                <MenuItem className={`${styles.erp_lable}`} value="" selected>Not Required</MenuItem>
                                                <MenuItem className={`${styles.erp_lable}`} value="/" >/</MenuItem>
                                                <MenuItem className={`${styles.erp_lable}`} value="_" >_</MenuItem>
                                            </ERPinput>

                                        </Grid>
                                        <Grid item md={2} style={{}}>
                                            <ERPinput
                                                fullWidth
                                                label='Year'
                                                size='small'
                                                type="text"
                                                onChange={handleChange}
                                                name="year"
                                                value={(data.year)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { fontSize: 12, color: '#000000' }
                                                }}
                                            />

                                        </Grid>
                                        <Grid item md={3} style={{}}>
                                            <ERPinput
                                                fullWidth
                                                label='Start No'
                                                size='small'
                                                type="text"
                                                onChange={handleChange}
                                                name="startNo"
                                                value={(data.startNo)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { fontSize: 12, color: '#000000' }
                                                }}
                                                maxLength={parseInt(data.digit, 10)}
                                            />

                                        </Grid>
                                        <Grid item md={3} style={{}}>


                                        </Grid>
                                        <Grid item md={6}>
                                            {/* <FormControlLabel control={<Checkbox />} label="Change With Fin Year" /> */}
                                            <FormControlLabel
                                                control={<Checkbox size='small'
                                                    // defaultChecked={sameAddressCondition}
                                                    name='changeWithFinYear'
                                                    value={changeWithFinYear}
                                                    onChange={handleChangeCheckbox}
                                                />}
                                                label={
                                                    <Typography style={{ fontSize: '12px' }}>
                                                        Change With Fin Year
                                                    </Typography>
                                                }
                                            />
                                        </Grid>
                                        <Grid item md={12} style={{}}>
                                            <Box sx={{ marginTop: '12px', float: 'right' }}>
                                                <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                                    <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                                                </Button>
                                                <Cancel />
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        </Grid>
                    </form>
                </Paper>

                {successMessage &&
                    <Snackbar
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        open={successMessage}
                        autoHideDuration={2000}
                        message={successMessage}
                    />
                }
            </div>
        </>
    )
}
export default DocumentNumbringFormate;